import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream" data-id="element-33" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-5xl px-6 py-20 md:py-24" data-id="element-34" data-mp="1o33u6h0ytshr">
        <div className="flex flex-col gap-8 rounded-2xl border border-ink-line bg-cream-deep p-8 md:flex-row md:items-center md:gap-12 md:p-12" data-id="element-35" data-mp="223y4j57kq3j2">
          <ShieldCheckIcon className="h-12 w-12 shrink-0 text-terracotta" aria-hidden="true" strokeWidth={1.5} data-id="element-36" data-mp="1x54p378q82g9" />
          <div data-id="element-37" data-mp="14gfnl73rdv3z">
            <h2 className="font-serif text-4xl leading-none text-terracotta md:text-5xl" data-id="element-38" data-mp="14gz4ckhoadgf">
              Sin riesgo
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-ink md:text-xl" data-id="element-39" data-mp="1j6n8dth8nq7u">
              7 días de garantía. Si no te gusta, reembolso completo. Sin preguntas.
            </p>
            <p className="mt-2 text-base italic text-ink-faint" data-id="element-40" data-mp="qmooytrkfvn1">(Pero no creo que lo pidas.)</p>
          </div>
        </div>
      </div>
    </section>;
}